import { BookOpen, ChevronDown } from "lucide-react";
import { useEffect, useId, useRef, useState } from "react";

import { Link } from "./Link";

const ITEMS = [
  {
    to: "/manual",
    title: "교사용 매뉴얼",
    note: "학급 만들기부터 학생이 그리기까지",
  },
  {
    to: "/manual/student",
    title: "학생용 안내문",
    note: "인쇄해서 나눠 주는 한 장",
  },
] as const;

/**
 * 「매뉴얼」 단추와 교사용·학생용을 고르는 드롭다운. 랜딩·로그인 후 헤더·매뉴얼
 * 머리에 같은 것을 둔다. 바깥을 누르거나 Esc를 누르면 닫힌다.
 */
export const ManualMenu = ({
  variant = "app",
}: {
  /** app: 남색 헤더 안, landing: 랜딩·매뉴얼의 흰 머리 안. */
  variant?: "app" | "landing";
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const menuId = useId();

  useEffect(() => {
    if (!open) {
      return;
    }
    const onPointer = (event: PointerEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setOpen(false);
        buttonRef.current?.focus();
      }
    };
    document.addEventListener("pointerdown", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className={`cs-manual-menu cs-manual-menu--${variant}`} ref={rootRef}>
      <button
        ref={buttonRef}
        type="button"
        className="cs-manual-menu-button"
        aria-expanded={open}
        aria-controls={menuId}
        onClick={() => setOpen((value) => !value)}
      >
        <BookOpen size={16} aria-hidden="true" />
        매뉴얼
        <ChevronDown
          size={16}
          aria-hidden="true"
          className="cs-manual-menu-chevron"
        />
      </button>
      {open && (
        <ul id={menuId} className="cs-manual-menu-panel" aria-label="매뉴얼">
          {ITEMS.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className="cs-manual-menu-link"
                onClick={() => setOpen(false)}
              >
                <span className="cs-manual-menu-title">{item.title}</span>
                <span className="cs-manual-menu-note">{item.note}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
